/** @jsxImportSource react */

import cx from 'classnames';
import { bool, string } from 'proptypes';
import React, { forwardRef } from 'react';

const defaultClass =
  'font-b-m py-s px-l rounded-box placeholder:text-slate-lighter-40 focus:outline-none active:outline-none  h-12';

const getStyles = (props) => {
  return cx(
    defaultClass,
    props.disabled ? 'bg-slate-lighter-90 text-slate-lighter-40' : '',
    props.error ? 'bg-[#DC3133]' : '',
    props.error ? 'hover:border-[#DC3133]' : 'hover:border-slate-lighter-60',
    props.error ? 'focus:border-[#DC3133]' : 'focus:border-viridian-base',
    props.error ? 'active:border-[#DC3133]' : 'active:border-viridian-base',
    props.className
  );
};

const Input = forwardRef(({ type = 'text', ...props }, ref) => (
  <input
    type={type}
    {...props}
    className={getStyles(props)}
    ref={ref}
    data-tp-id='gen-input-1ba7eca3-8e86-4dfa-addf-6d0c35ce1eda'
  />
));

Input.propTypes = {
  type: string,
  disabled: bool,
};

Input.displayName = 'Input';

export default Input;
